import gsap from "gsap";
import { sizes } from "@/js/sizes";

export default {
	name: "SliderModule",
	data() {
		return {
			prev: null,
			current: 0,
			rotate: 36,
			nextScale: 1,
			prevScale: 0.9,
			prevTargetArrow: null,
			nextTargetArrow: null,
			contentTl: null,
			circle: null,
			imgTl: null,
			allImg: null,
			allTitle: null,
			allText: null,
			allPoint: null,
			allDots: null,
			heightContent: 0,
			circleWidth: Number,
			tlEnter: null,
			tlLeave: null
		};
	},
	props: {
		module,
	},
	created() {
		window.addEventListener('load', () => this.setContentWrapperHeight())
	},
	mounted() {
		this.resizeEv()
		this.observeAnimation();

		this.contentTl = gsap.timeline()
		this.imgTl = gsap.timeline()
		gsap.set(this.$refs.circlenav, { rotate: this.rotate })

		this.allTitle = document.querySelectorAll('.slider__wrapper__content__title')
		this.allText = document.querySelectorAll('.slider__wrapper__content__text')
		this.allPoint = document.querySelectorAll('.slider__wrapper__content__list')
		this.allImg = document.querySelectorAll('.slider__circle__img')
		this.circle = document.querySelectorAll('.slider__circle')
		this.allDots = document.querySelectorAll(".slider_dot")
		this.circleWidth = parseFloat(window.getComputedStyle(this.$refs.imgWrapper).width);


		window.addEventListener("resize", this.resizeEv);
		this.$el.addEventListener("mousemove", this.onMouseMove);
	},
	methods: {
		observeAnimation() {
			let optionsEnter = {
				rootMargin: "0px",
				threshold: 0.25
			}
			this.leaveAnim();

			let observerEnter = new IntersectionObserver(entries => {
				entries.forEach(enter => {
					if (enter.intersectionRatio > 0.25 && enter.boundingClientRect.top > 0) {
						this.enterAnim()
					}
				})
			}, optionsEnter);

			observerEnter.observe(this.$refs.sliderContainer);


			let optionsLeave = {
				rootMargin: "0px",
				threshold: 0
			}

			let observerLeave = new IntersectionObserver(entries => {
				entries.forEach(enter => {
					if (enter.intersectionRatio == 0 && enter.boundingClientRect.top > 0) {
						this.leaveAnim()
					}
				})
			}, optionsLeave);

			observerLeave.observe(this.$refs.sliderContainer);
		},
		setContentWrapperHeight() {
			this.getHeighestContent()

			const navHeight = this.$refs.nav.offsetHeight
			const navMarginTop = 83
			const typeHeight = document.querySelector('.slider__background__type').offsetHeight
			const paddingBottomMobile = 50

			const paddingTop = window.innerWidth < sizes.b ? 200 :
				window.innerWidth < sizes.c ? 200 : 120

			if (window.innerWidth < sizes.c) {
				document.querySelector('.slider__background').style.height = this.heightContent + typeHeight / 2 + paddingBottomMobile + 'px'
				document.querySelector('.slider__container').style.height = this.heightContent + paddingTop + navHeight + typeHeight / 2 + paddingBottomMobile + 'px'
				document.querySelector('.slider').style.height = this.heightContent + typeHeight / 2 + paddingBottomMobile + 'px'
			} else {
				document.querySelector('.slider__background').style.height = this.heightContent + paddingTop * 2 + typeHeight + navMarginTop + 'px'
				document.querySelector('.slider__container').style.height = this.heightContent + paddingTop * 2 + typeHeight + navMarginTop + 'px'
				document.querySelector('.slider').style.height = this.heightContent + paddingTop * 2 + typeHeight + navMarginTop + 'px'
				this.$refs.nav.style.bottom = paddingTop + 'px'
			}

			document.querySelectorAll(".slider__wrapper").forEach((el, i) => {
				el.style.marginTop = -document.querySelectorAll(".slider__wrapper")[i - 1]?.offsetHeight
				el.style.paddingTop = paddingTop + typeHeight + 'px'
			})

			this.$refs.portfolio.style.top = paddingTop
		},
		getHeighestContent() {
			const heights = []

			const contents = window.innerWidth < sizes.c ? document.querySelectorAll('.slider__wrapper') : document.querySelectorAll('.slider__wrapper__content')

			contents.forEach(el => {
				heights.push(el.clientHeight)
			})

			this.heightContent = Math.max(...heights)
		},
		enterAnim() {
			this.tlEnter = gsap.timeline();

			if (this.tlLeave && this.tlLeave.isActive()) {
				this.tlLeave.kill();
			}

			if (window.innerWidth > sizes.c) {
				this.tlEnter
					.to([this.$refs.portfolio, this.$refs.slider], { y: 0, autoAlpha: 1, })
					.to(this.$refs.circle, { opacity: 1, marginTop: 0, clearProps: 'marginTop' }, '-=0.3')
					.to(this.$refs.next, { autoAlpha: 1 }, '-=0.3')
					.to(this.$refs.prev, { autoAlpha: 0.5 }, '-=0.7')
			} else {
				this.tlEnter
					.to(this.$refs.background, { autoAlpha: 1, y: 0 })
					.to(this.$refs.circle, { marginTop: 0 }, '-=0.4')
					.to([this.$refs.portfolio, this.$refs.slider], { y: 0, autoAlpha: 1 }, '-=0.1')
			}
		},
		leaveAnim() {
			this.tlLeave = gsap.timeline();

			if (this.tlEnter && this.tlEnter.isActive()) {
				this.tlEnter.kill();
			}

			if (window.innerWidth > sizes.c) {
				this.tlLeave
					.to([this.$refs.portfolio, this.$refs.slider], { autoAlpha: 0, y: 150 })
					.to(this.$refs.circle, { opacity: 0, marginTop: 150 }, '-=0.3')
					.to(this.$refs.next, { autoAlpha: 0 }, '-=0.3')
					.to(this.$refs.prev, { autoAlpha: 0 }, '-=0.7')
			} else {
				this.tlLeave
					.to(this.$refs.background, { autoAlpha: 0, y: 200 })
					.to(this.$refs.circle, { marginTop: 120 }, '-=0.4')
					.to([this.$refs.portfolio, this.$refs.slider], { autoAlpha: 0, y: 50 }, '-=0.1')
			}
		},
		hoverIn(arr) {
			if (arr === 'next') {
				gsap.to(this, { duration: 0.3, nextScale: 1.1 })
			} else {
				gsap.to(this, { duration: 0.3, prevScale: 1.06 })
			}

		},
		hoverOut(arr) {
			if (arr === 'next') {
				gsap.to(this, 0.3, { nextScale: 1 })
			} else {
				gsap.to(this, 0.3, { prevScale: 0.9 })
			}
		},
		onMouseMove(ev) {
			// some data should be cached in mounted and recalculated on resize
			const sliderSizes = this.$refs.circlenav.getBoundingClientRect();
			const center = sliderSizes.x + sliderSizes.width / 2;
			const isLeft = ev.clientX < center;
			const posY = (ev.clientY - sliderSizes.y) / sliderSizes.height;
			let deg = posY < 0 ? 0 : posY > 1 ? 180 : posY * 180;
			if (isLeft) {
				deg = 180 - deg;
			}
			this.rotate = Math.min(140, Math.max(40, deg));

			gsap.to(this.$refs.circlenav, { duration: 0.5, rotate: this.rotate })
		},
		resizeEv() {
			this.circleWidth = parseFloat(window.getComputedStyle(this.$refs.imgWrapper).width);
			this.setCirclePos()
			this.setArrowPos()
			this.setContentWrapperHeight()
			this.setConstElements();
		},
		setArrowPos() {
			this.prevTargetArrow = window.innerWidth < sizes.c ? this.$refs.prevTablet : this.$refs.prev
			this.nextTargetArrow = window.innerWidth < sizes.c ? this.$refs.nextTablet : this.$refs.next
		},
		setCirclePos() {
			gsap.set(this.$refs.imgWrapper, { x: -this.circleWidth * this.current })
			this.$refs.circle.style.height = this.$refs.circle.getBoundingClientRect().width
			if (window.innerWidth < sizes.c) this.$refs.sliderContainer.style.paddingTop = this.$refs.circle.getBoundingClientRect().width / 2
		},
		onSwipe(dir, ev) {
			if (window.innerWidth > sizes.c) return;
			let direction = dir.type === "swipeleft" ? "right" : "left";
			this.incrementOrDecrementCurrent(direction);

			if (ev) {
				this.arrowAnimOnClick(direction)
			}

			if (window.innerWidth < sizes.d && window.innerWidth > sizes.c) {
				direction = dir.type === "swipeleft" ? "left" : "right";
				this.changeSlideDesktop(direction)
			}
		},
		onNaviClick(e) {
			this.prev = this.current;
			this.current = +(e.currentTarget.dataset.slide)
			if (this.prev === this.current) return;

			const dir = this.prev > this.current ? 'left' : ' right'
			const func = window.innerWidth < sizes.c ? "changeSlideMobile" : "changeSlideDesktop";
			this[func](dir);
			this.changeNaviDotsColor();

			if (e.currentTarget.dataset.slide == this.module.length - 1) {
				this.determineFirstLast('right')
			} else if (e.currentTarget.dataset.slide == 0) {
				this.determineFirstLast('left')
			} else {
				this.determineFirstLast()
			}
		},
		changeNaviDotsColor() {
			this.allDots.forEach((el, i) => {
				el.classList.add("slider__nav__dots--hidden");
				if (this.current === i) el.classList.remove("slider__nav__dots--hidden");
			});
		},
		changeSlideDesktop(dir, e) {
			if (e) this.incrementOrDecrementCurrent(dir);
			if (e) this.arrowAnimOnClick(dir)

			const direction = dir === 'left' ? 70 : -70
			this.animateChangeContent(-direction)
			this.animateChangeImg(-direction)
			this.determineFirstLast(dir)
		},
		changeSlideMobile(dir) {
			const direction = dir === 'left' ? 60 : -60
			const directionCircle = dir === 'left' ? 100 : -100

			this.animateChangeContent(direction)
			this.animateChangeImg(direction, directionCircle)

		},
		animateChangeContent(direction) {
			if (this.contentTl && this.contentTl.isActive()) {
				this.contentTl.progress(1)
			}

			const speed = window.innerWidth < sizes.d ? 0.4 : 0.48

			let dir = direction

			if (window.innerWidth < sizes.c) {
				dir = -direction
			}

			this.contentTl
				.to(this.allTitle[this.prev], { opacity: 0, x: -dir, duration: speed + 0.12, ease: "power1.inOut" })
				.to(this.allText[this.prev], { opacity: 0, x: -dir, dir: speed + 0.19, ease: "power1.inOut" }, '-=0.44')
				.to(this.allPoint[this.prev], { opacity: 0, x: -dir, duration: speed + 0.26, ease: "power1.inOut" }, '-=0.48')
				.fromTo(this.allTitle[this.current], { x: dir }, { opacity: 1, x: 0, duration: speed + 0.12, ease: "power1.inOut" }, '-=0.3')
				.fromTo(this.allText[this.current], { x: dir }, { opacity: 1, x: 0, duration: speed + 0.2, ease: "power1.inOut" }, '-=0.55')
				.fromTo(this.allPoint[this.current], { x: dir }, { opacity: 1, x: 0, duration: speed + 0.3, ease: "power1.inOut" }, '-=0.58')
		},
		animateChangeImg() {
			if (this.imgTl && this.imgTl.isActive()) {
				this.imgTl.progress(1)
			}

			const duration = window.innerWidth < sizes.d ? 0.8 : 1.6
			gsap.to(this.$refs.imgWrapper, { x: -this.circleWidth * this.current, ease: "power3.inOut", duration: duration, force3D: false })

		},
		incrementOrDecrementCurrent(dir) {
			this.prev = this.current;

			if (dir === "left") {
				if (this.current === 0) return;
				this.current -= 1;
			} else if (dir === "right") {
				if (this.current === this.module.length - 1) return;
				this.current += 1;
			}
			this.determineFirstLast(dir)
			this.changeNaviDotsColor();
			if (window.innerWidth < sizes.c) this.changeSlideMobile(dir)
		},
		arrowAnimOnClick(dir) {
			const prev = window.innerWidth < sizes.c ? this.$refs.prevTablet : this.$refs.prev
			const next = window.innerWidth < sizes.c ? this.$refs.nextTablet : this.$refs.next

			const target = dir === 'left' ? prev : next

			target.children[0].style.transition = '0s'

			gsap.timeline().to(target.children[0], { x: 60, duration: 0.3 })
				.set(target.children[0], { x: -60 })
				.to(target.children[0], { x: 0, duration: 0.3, clearProps: 'transform', onComplete: () => target.children[0].style.transition = 'transform 0.3s' })
		},
		determineFirstLast(dir) {
			if (this.current === 0 || this.current === this.module.length - 1) {
				if (dir === 'left') {
					gsap.to(this.prevTargetArrow, 0.2, { opacity: 0.5, pointerEvents: 'none' })
					gsap.to(this.nextTargetArrow, 0.2, { opacity: 1, pointerEvents: 'auto' })
				} else if (dir === 'right') {
					gsap.to(this.nextTargetArrow, 0.2, { opacity: 0.5, pointerEvents: 'none' })
					gsap.to(this.prevTargetArrow, 0.2, { opacity: 1, pointerEvents: 'auto' })
				}
			} else {
				gsap.to(this.prevTargetArrow, 0.2, { opacity: 1, pointerEvents: 'auto' })
				gsap.to(this.nextTargetArrow, 0.2, { opacity: 1, pointerEvents: 'auto' })
			}
		},
		setConstElements() {
			if (window.matchMedia('(min-width: 801px)').matches) {
				const contentLeftOffset = this.$refs.content.getBoundingClientRect().left;
				const gridLeft = this.$refs.background.getBoundingClientRect().left;
				this.$refs.nav.style.left = `${contentLeftOffset - gridLeft}px`

				if (window.matchMedia('(min-width: 1201px)').matches) {
					this.$refs.portfolio.style.left = `${contentLeftOffset - gridLeft}px`;
				} else {
					this.$refs.portfolio.style.removeProperty('left');
				}
			} else {
				this.$refs.nav.style.removeProperty('left');
				this.$refs.portfolio.style.removeProperty('left');
			}
		}
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.resizeEv);
		this.$el.removeEventListener("mousemove", this.onMouseMove);
	},
};
